import { recipe } from "@vanilla-extract/recipes";

import { transition } from "../../utils/transition";
import { theme } from "../../theme/css/theme.css";

export const addOnStyle = recipe({
  base: {
    alignSelf: "stretch",
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    lineHeight: 0,
    gap: theme.spacings.xxs,
    transition: transition("border-color"),
  },
  variants: {
    variant: {
      leading: {
        // paddingRight: rem(12),
        // borderRight: `1px solid var(--border-color)`,
        selectors: {
          "&:has(.select)": {
            // paddingRight: rem(6),
          },
        },
      },
      trailing: {
        // paddingLeft: rem(12),
        // borderLeft: `1px solid var(--border-color)`,
      },
    },
  },
});
